import React from 'react';
import { Grid, Col, Title } from '@common/components';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import mainClasses from './MainView.module.scss';

export default function MainView(props) {
  const { children } = props;
  return (
    <div className={mainClasses.main}>
      <Grid>
        <Col className={mainClasses.index} sm={3} xs={12}>
          <nav className={mainClasses.navigation}>
            <Title type="h2">Ejemplos:</Title>
            <Link to="grid">Grids</Link>
            <Link to="icon">Icons</Link>
            <Link to="loader">Loader</Link>
            <Link to="button">Buttons</Link>
            <Link to="input">Inputs</Link>
            <Link to="card">Cards</Link>
            <Link to="modal">Modals</Link>
          </nav>
        </Col>
        <Col sm={9} xs={12}>
          <div className={mainClasses.content}>{children}</div>
        </Col>
      </Grid>
    </div>
  );
}

MainView.propTypes = {
  children: PropTypes.node,
};
